import { memo } from 'react'
import { WalletGrid, WalletSelection } from './styles'
import { useOrderedConnections } from './useOrderedConnections'

export const EvmWalletSelection = memo(() => {
  const { orderedConnections } = useOrderedConnections()

  return (
    <WalletSelection>
      {/*<WalletType>*/}
      {/*  <AccountBalanceWalletIcon sx={{ fontSize: '20px' }} />*/}
      {/*  EVM Wallets*/}
      {/*</WalletType>*/}
      <WalletGrid>{orderedConnections}</WalletGrid>
    </WalletSelection>
  )
})
